import { BaseForm } from '~base/BaseForm';

export enum MessageFormField {
  message = 'message',
}

export class MessageForm extends BaseForm {
  message: string = '';

  constructor(props?: unknown) {
    super(props);
    this.load(props);
  }
}
